import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useProgramsStore } from '@/stores/programs';
import { useUiStore } from '@/stores/ui';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VLimitTag',
  props: {
    title: null,
    report: null
  },
  setup(__props: any) {

const props = __props as { title?: string, report?: any }



const title = computed(() => {
  return props.report?.keyLimit ?? props.title
}) 

const colors: any = {
  "Цели": "#5761E3",
  "Возможность": "#EF9275",
  "Востребованность": "#A557E3",
  "Реализуемость": "#D857E3",
  "Жизнеспособность": "#1EC776",
  "Адаптируемость": "#35BEE9",
}

const programsStore = useProgramsStore()
const tooltip = computed(() => {
  if (!props.report) return ""
  const arr = programsStore.limitsMeta.filter(item => item.category === props.report.keyLimit)

  const _arr = arr.map(item => item.title + " - " + props.report.fields[item.title] )
  if (props.report.fields["Комментарий к ограничению"]) {
    _arr.push(props.report.fields["Комментарий к ограничению"])
  }
  return _arr.join("\r\n")
})
const uiStore = useUiStore()
const openTooltip = (e: MouseEvent) => {
  if (!tooltip.value) return
  uiStore.openTooptip(e, tooltip.value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "v-limit-tag",
    style: _normalizeStyle({ backgroundColor: colors[_unref(title)] }),
    onMouseenter: openTooltip
  }, _toDisplayString(_unref(title)), 37))
}
}

})